export default __webpack_public_path__ + "static/cover-big-yangol-68bc1217f86555d2e6b1fee44a1c93da.png";